export default __webpack_public_path__ + "static/media/redemption_navicon-light.aad34090.svg";